import React, { useState, useEffect } from 'react';
import loggerIntegrationApi from '../../../services/apiServices/loggerIntegrationApi';
import { setLoading } from '../../../services/redux/loadingSlice';
import { useDispatch } from 'react-redux';
import configService from '../../../services/configService';
import Pagination from '../../../components/common/Pagination/Pagination';
import { toast } from 'react-toastify';
import { putDateOnPattern } from '../../../utils/functions';
import FilterComponent from '../../../components/admin/FilterComponent/FilterComponent';
import { useNavigate, useSearchParams } from 'react-router-dom';


const LogIntegrationListPage = () => {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();
    const [items, setItems] = useState([]);
    const [page, setPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState(searchParams.get('term') || '');
    const [startDate, setStartDate] = useState(searchParams.get('startDate') || '');
    const [endDate, setEndDate] = useState(searchParams.get('endDate') || '');
    const [totalPages, setTotalPages] = useState(1);
    const [totalItens, setTotalItens] = useState(0);
    const quantity = configService.getDefaultNumberOfItemsTable();
    const [showFilters, setShowFilters] = useState(searchParams.toString().length > 0);
    const toggleFilters = () => setShowFilters(prev => !prev);
    const orderBy = "Created:Desc";

    useEffect(() => {
        const fetchLogs = async () => {
            dispatch(setLoading(true));
            try {
                const response = await loggerIntegrationApi.getLoggerIntegrationPaginated({
                    page,
                    quantity,
                    orderBy,
                    term: searchTerm || undefined,
                    startDate: startDate || undefined,
                    endDate: endDate || undefined
                });
                setItems(response.Results || []);
                setTotalPages(response.TotalPages || 1);
                setTotalItens(response.TotalCount || 0);
            } catch (error) {
                toast.error('Erro ao buscar os itens.');
            } finally {
                dispatch(setLoading(false));
            }
        };
        fetchLogs();
    }, [page, quantity, searchTerm, startDate, endDate, dispatch]);

    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= totalPages) {
            setPage(newPage);
        }
    };

    const search = ({term, startDate, endDate} = {}) => {
        setSearchTerm(term || '');
        setStartDate(startDate || '');
        setEndDate(endDate || '');
        setPage(1);

        const nextParams = new URLSearchParams();
        if (term) nextParams.set('term', term);
        if (startDate) nextParams.set('startDate', startDate);
        if (endDate) nextParams.set('endDate', endDate);
        setSearchParams(nextParams);
    }

    const exportFunction = async (term) => {
        try {
            dispatch(setLoading(true));
            const response = await loggerIntegrationApi.exportLogs({ term: term, startDate, endDate });

            if (response.Status === 200 && response.Object) {
                window.open(response.Object, "_blank");
                toast.success('Relatório gerado com sucesso!');
            } else {
                toast.error('Erro ao gerar o relatório');
            }
        } catch (error) {
            toast.error('Erro ao gerar o relatório');
        }
        finally{
            dispatch(setLoading(false));
        }
    };

    const openItem = (code) => {
        navigate(`${code}`);
    }

    return (
    <div className="container-admin-page">
        <div className='title-with-options'>
            <h1>Lista de Integrações</h1>

            <button className="main-button" onClick={toggleFilters}>
                {showFilters ? 'Ocultar Filtros' : 'Mostrar Filtros'}
            </button>
        </div>

        {showFilters && (
            <div className='container-admin-page-filters div-with-border'>
                <h3>Filtros</h3>
                <FilterComponent
                    placeHolder={'Número do pedido'}
                    showTermFilter={true}
                    showStartDate={true}
                    showEndDate={true}
                    initialTerm={searchTerm}
                    initialStartDate={startDate}
                    initialEndDate={endDate}
                    submitFilter={search}
                    exportFunction={exportFunction}/>
            </div>
        )}


        <div className='container-admin-page-table div-with-border'>
            <table className="admin-table">
                <thead>
                    <tr>
                        <th>Id</th>
                        <th>Número pedido</th>
                        <th>Texto</th>
                        <th>Criado</th>
                    </tr>
                </thead>
                <tbody>
                {items.map((item) => (
                    <tr key={item.Id}>
                        <td data-label='Id'>
                            <span className='option-link' onClick={() => openItem(`${item.Id}`)}>
                                {item.Id}
                            </span>
                        </td>
                        <td data-label='Número pedido'>
                            <span className='option-link' onClick={() => openItem(`${item.Id}`)}>
                                {item.OrderId}
                            </span>
                        </td>
                        <td data-label='Texto'>
                            <span className='option-link' onClick={() => openItem(`${item.Id}`)}>
                                {item.TextLog.length > 100
                                    ? `${item.TextLog.substring(0, 100)}...`
                                    : item.TextLog}
                            </span>
                        </td>
                        <td data-label='Criado'>
                            <span className='option-link' onClick={() => openItem(`${item.Id}`)}>
                                {putDateOnPattern(item.Created)}
                            </span>
                        </td>
                    </tr>
                ))}
                {items.length === 0 && (
                    <tr>
                        <td colSpan="4">Nenhuma integração encontrada para os filtros selecionados.</td>
                    </tr>
                )}
                </tbody>
            </table>
            <sub>Total de Integrações: {totalItens}</sub>
            <Pagination page={page} totalPages={totalPages} onPageChange={handlePageChange} />
        </div>
    </div>
    );
};

export default LogIntegrationListPage;
